import { render, staticRenderFns } from "./lxwmDrawer.vue?vue&type=template&id=2a0af1b2&"
import script from "./lxwmDrawer.vue?vue&type=script&lang=js&"
export * from "./lxwmDrawer.vue?vue&type=script&lang=js&"
import style0 from "./lxwmDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports